import React, { useState, useEffect, useCallback } from "react";
import { initialData } from "./dashboardData";
import Header from "./Header";
import BatchProfileSection from "./BatchProfileSection";
import CEEPerformanceSection from "./CEEPerformanceSection";
import CoreSkillsAssessmentSection from "./CoreSkillsAssessmentSection";
import CollegeDashboardSkeleton from "./CollegeDashboardSkeleton";
import PerformanceInsightsSection from "./PerformanceInsightsSection";
import Super30JobsSection from "./Super30JobsSection";
import RoleListModal from "./RoleListModal";
import StudentListModal from "./StudentListModal";
import "./style.css";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import CCService from "../../../services/httpServiceWithoutSuperAdmin";
import ThreePAnalysisCard from "./ThreePAnalysisCard";
import RoleAnalysisModal from "./RoleAnalysisModal";
import { IncompleteStudentsModal } from "./IncompleteStudentsModal";

const CollegeDashboard = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const batchId = location.state?.batch_id || id;
  const services = new CCService();
  const [CEEOptions, setCEEOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const [selectedCeeId, setSelectedCeeId] = useState("");
  const [isRoleModalOpen, setIsRoleModalOpen] = useState(false);
  const [roleAnalysisModal, setRoleAnalysisModal] = useState(false);
  const [isStudentModalOpen, setIsStudentModalOpen] = useState(false);
  const [modalStudentList, setModalStudentList] = useState([]);
  const [modalRoleList, setModalRoleList] = useState([]);
  const [roleCountList, setRoleCountList] = useState([]);
  const [allModalStudents, setAllModalStudents] = useState([]);
  const [isIncompleteStudentsModalOpen, setIsIncompleteStudentsModalOpen] = useState(false);
  const getAllRoles = async () => {
    try {
      const response = await services.get(
        `/collegeAdmin/preferedRoleCount?cee_id=B2B${selectedCeeId}`
      );

      setModalRoleList(response.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const getAllRoleCount = async () => {
    try {
      const response = await services.get(
        `/collegeAdmin/ceeRoleWiseCount?cee_id=B2B${selectedCeeId}`
      );

      setRoleCountList(response.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const getStudentList = async () => {
    try {
      const response = await services.get(
        `/collegeAdmin/ceeCandidates?cee_id=B2B${selectedCeeId}`
      );
      setAllModalStudents(response.data);
      setModalStudentList(response.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const transformBackendToDashboard = (backendData, ceeOptions = []) => {
    const { data } = backendData;
    console.log("backendData", backendData);
    const safeValue = (value, fallback = 0) => value || fallback;
    const generalStats = {
      totalStudentsInBatch: safeValue(data.metaData?.totalStudentCount, 0),
      totalCEETakers: safeValue(data.metaData?.attemptedStudent, 0),
      avgEmployability: `${safeValue(data.metaData?.avgEmployability, 0)}%`,
      projectedAvgSalary: `₹${(
        safeValue(data.metaData?.avgSalary, 0) / 100000
      ).toFixed(1)} LPA`,
    };
    const transformCoreSkills = (skills) => {
      const skillIconMapping = {
        "Written Communication": {
          iconPath:
            "M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 3a4 4 0 100 8 4 4 0 000-8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75",
          iconBg: "bg-blue-100",
          iconColor: "text-blue-600",
          description:
            "Ability to express ideas clearly and effectively in writing",
        },
        "Business Acumen": {
          iconPath:
            "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
          iconBg: "bg-yellow-100",
          iconColor: "text-yellow-600",
          description:
            "Understanding of how businesses operate and make decisions",
        },
        Negotiation: {
          iconPath: "M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4",
          iconBg: "bg-indigo-100",
          iconColor: "text-indigo-600",
          description:
            "Ability to reach agreements through effective discussion and compromise",
        },
        "Attention to Detail": {
          iconPath:
            "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z",
          iconBg: "bg-green-100",
          iconColor: "text-green-600",
          description:
            "Ability to thoroughly review work and notice small yet important elements",
        },
        "Verbal Communication": {
          iconPath:
            "M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.522 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.478 0-8.268-2.943-9.542-7z",
          iconBg: "bg-purple-100",
          iconColor: "text-purple-600",
          description: "Ability to articulate thoughts clearly in speech",
        },
        "Problem Solving": {
          iconPath: "M13 10V3L4 14h7v7l9-11h-7z",
          iconBg: "bg-red-100",
          iconColor: "text-red-600",
          description:
            "Ability to identify issues and determine effective solutions",
        },
        "Data Interpretation": {
          iconPath: "M3 3v18h18M9 17l3-3 4 4M9 11l3-3 4 4",
          iconBg: "bg-teal-100",
          iconColor: "text-teal-600",
          description:
            "Ability to analyze and draw conclusions from data patterns",
        },
        "Quantitative Ability": {
          iconPath: "M4 6h16M4 12h16M4 18h16",
          iconBg: "bg-pink-100",
          iconColor: "text-pink-600",
          description:
            "Proficiency with numerical reasoning and mathematical problem-solving",
        },
      };
      return (skills || []).map((skill) => {
        const iconData = skillIconMapping[skill.skill] || {
          iconPath: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z",
          iconBg: "bg-gray-100",
          iconColor: "text-gray-600",
          description: `Assessment of ${skill.skill} capabilities`,
        };
        const poorPerformersCount = Math.round(skill.poorPerformer || 0);
        return {
          name: skill.skill,
          description: iconData.description,
          batchAvgScore: Math.round(safeValue(skill.avgScore, 0)),
          poorPerformersCount,
          iconPath: iconData.iconPath,
          iconBg: iconData.iconBg,
          iconColor: iconData.iconColor,
        };
      });
    };
    const transformDemographics = (demographics) => {
      const transformGenderData = (genderData) => {
        const genderMapping = {
          Male: {
            color: "primary-500",
            iconPath:
              "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z",
          },
          Female: {
            color: "secondary-500",
            iconPath:
              "M12 2a2 2 0 012 2v2a2 2 0 01-2 2 2 2 0 01-2-2V4a2 2 0 012-2zm0 8c1.657 0 3 1.343 3 3v5a2 2 0 01-2 2h-2a2 2 0 01-2-2v-5c0-1.657 1.343-3 3-3z",
          },
          Others: {
            color: "gray-400",
            iconPath:
              "M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4",
          },
          "Not Specified": {
            color: "neutral-300",
            iconPath:
              "M12 2a10 10 0 100 20 10 10 0 000-20zm0 4a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm0 5c.828 0 1.5.672 1.5 1.5v4a1.5 1.5 0 11-3 0v-4c0-.828.672-1.5 1.5-1.5z",
          },
        };
        return genderData.map((item) => {
          const genderMap = genderMapping[item.label] || {
            iconPath: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z",
            color: "text-gray-600",
          };
          const totalCount = genderData.reduce(
            (acc, curr) => acc + safeValue(curr.count, 0),
            0
          );
          return {
            label: item.label,
            percentage: Math.round(
              safeValue(((item.count * 100) / totalCount).toFixed(2), 0)
            ),
            iconPath: genderMap.iconPath,
            color: genderMap.color,
          };
        });
      };
      return {
        genderDistribution:
          transformGenderData(demographics?.genderDistribution) || [],
        branchDistribution: demographics?.branchDistribution || [],
        topPreferredRoles: (demographics?.topPreferredRoles || []).map(
          (role) => ({
            name: role.name,
            count: role.count,
            iconPath: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z",
          })
        ),
        insight: `${demographics?.insight?.percentage}% of the batch has shown a preference of ${demographics?.insight?.name} specialization
`,
      };
    };
    const transformSalaryRoleAnalysis = (salaryData) => {
      const colorMapping = {
        "0-6 L": "rgba(147, 197, 253, 0.75)",
        "6-9 L": "rgba(96, 165, 250, 0.75)",
        "9-12 L": "rgba(59, 130, 246, 0.75)",
        "12L +": "rgba(37, 99, 235, 0.75)",
        "No match": "rgba(239, 68, 68, 0.75)",
      };
      return {
        projectedSalaryDistribution: (
          salaryData?.projectedSalaryDistribution || []
        ).map((item) => ({
          range: item.range,
          count: item.count,
          color: colorMapping[item.range] || "rgba(156, 163, 175, 0.7)",
        })),
        mostMatchedRoles: (salaryData?.mostMatchedRoles || []).slice(0, 5),
        insight:
          "These top 5 roles should be prioritized when inviting companies for campus placements.",
      };
    };
    const transformPerformanceOutliers = (outliers) => {
      const transformStudent = (student) => ({
        user_id: student.userId,
        name: student.fullName,
        score: student.empScore || 0,
        profilePicUrl: student.url || null,
      });
      return {
        topPerformers: (outliers?.topPerformers || []).map(transformStudent),
        bottomPerformers: (outliers?.bottomPerformers || []).map(
          transformStudent
        ),
        actionRequiredInsight: "Bottom 5% need intensive skill development.",
      };
    };
    const transformCeePerformanceMetrics = (metrics) => {
      const total_count = metrics.roleReadinessMetrics.reduce(
        (acc, metric) => acc + safeValue(metric.count, 0),
        0
      );
      const colorMapping = {
        strong: "bg-success-500",
        capable: "bg-warning-500",
        emerging: "bg-custom-blue",
        notFit: "bg-danger-500",
      };
      const descMapping = {
        strong:
          "Students with at least one of their roles in the strong level, showing greater role readiness according to our analysis.",
        capable:
          "Students with at least one of their roles in the capable level, showing decent role readiness according to our analysis.",
        emerging:
          "Students with at least one of their roles in the emerging level, showing minor role readiness with potential to upskill quickly.",
        notFit:
          "Students with no viable role matches, requiring intensive skill development or career counseling.",
      };
      const labelMapping = {
        strong: "Strong Fits",
        capable: "Capable Fits",
        emerging: "Emerging Fits",
        notFit: "No Fits",
      };
      return {
        roleReadinessMetrics: (metrics?.roleReadinessMetrics || []).map(
          (metric) => ({
            label: labelMapping[metric.label] || metric.label,
            percentage: safeValue(
              ((metric.count * 100) / total_count).toFixed(2),
              0
            ),
            color: colorMapping[metric.label] || "bg-gray-500",
            description: descMapping[metric.label],
          })
        ),
        insight: `77% of students have at least one viable career path or role fit.`,
      };
    };
    const transformAlignmentCategories = (categories) => {
      const colorMapping = {
        "High Misalignment": "red",
        "Partial Alignment": "amber",
        "Perfect Alignment": "green",
      };
      const alignmentMapping = {
        "High Misalignment": "misaligned",
        "Partial Alignment": "partial",
        "Perfect Alignment": "perfect",
      };
      const descMapping = {
        "High Misalignment":
          "Students whose profile, preferences, and performance show completely different career paths with no overlap between the three dimensions.",
        "Partial Alignment":
          "Students who show some alignment between two of the three dimensions (e.g., good at roles they like or qualified for roles they perform well in).",
        "Perfect Alignment":
          "Students with excellent alignment across all three dimensions - they prefer roles they're qualified for and perform well in during assessments.",
      };
      const iconMapping = {
        "High Misalignment":
          "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
        "Partial Alignment":
          "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
        "Perfect Alignment":
          "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
      };
      return (categories || []).map((category) => ({
        label: category.label,
        percentage: category.percentage,
        color: colorMapping[category.label] || "bg-gray-500",
        alignment: alignmentMapping[category.label],
        description: descMapping[category.label],
        iconPath: iconMapping[category.label],
      }));
    };
    const transformInsightsAndRecommendations = (recommendations) => {
      const descMapping = {
        "High Misalignment":
          "These students need career counseling to either adjust expectations or get targeted skill development.",
        "Partial Alignment":
          "Focus on bridging the gap between the two aligned dimensions and the third misaligned one.",
        "Perfect Alignment":
          "These students are placement-ready and should be fast-tracked for interviews with companies seeking these roles.",
      };
      return (recommendations || []).map((recommendation) => ({
        text: `${recommendation.label} (${Math.round(
          recommendation.percentage
        )}%): ${descMapping[recommendation.label]}`,
        type: "primary-600",
      }));
    };

    const transformStudentsToDisplayAccordingToAlignment = (students) => {
      return (students || []).map((student) => ({
        label: student.label,
        user_ids: student.user_ids,
      }));
    };
    const transformedData = {
      generalStats,
      ceeOptions: ceeOptions || [],
      sections: {
        batchProfilePerformance: {
          demographics: transformDemographics(
            data.batchProfilePerformance?.demographics
          ),
          salaryRoleAnalysis: transformSalaryRoleAnalysis(
            data.batchProfilePerformance?.salaryRoleAnalysis
          ),
          performanceOutliers: transformPerformanceOutliers(
            data.batchProfilePerformance?.performanceOutliers
          ),
        },
        ceePerformanceMetrics: transformCeePerformanceMetrics(
          data.ceePerformanceMetrics
        ),
        coreSkillsAssessment: {
          skills: transformCoreSkills(data.coreSkillsAssessment?.skills),
          insight:
            data.coreSkillsAssessment?.skills ||
            "Core skills assessment results for this batch.",
        },
        ...(data?.performanceInsights && {
          performanceInsights: {
            threePAnalysis: {
              description:
                "A proprietary framework by CareerCarve for analyzing alignment between student's Profile, Preferences, and Performance to optimize career paths.",
              dimensions: [
                {
                  name: "Profile",
                  subtext: "Resume & qualifications",
                  description:
                    "What a student is qualified for based on their education, skills, and experience.",
                  baseColor: "blue",
                  iconPath:
                    "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z",
                },
                {
                  name: "Preference",
                  subtext: "Career aspirations",
                  description:
                    "What a student wants to do based on their interests, values, and career goals.",
                  baseColor: "purple",
                  iconPath:
                    "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z",
                },
                {
                  name: "Performance",
                  subtext: "Assessment results",
                  description:
                    "What a student is actually good at based on assessment metrics and performance data.",
                  baseColor: "green",
                  iconPath:
                    "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z",
                },
              ],
              alignmentCategories: transformAlignmentCategories(
                data.performanceInsights?.alignmentCategories
              ),
              insightsAndRecommendations: transformInsightsAndRecommendations(
                data.performanceInsights?.alignmentCategories
              ),
              studentsToDisplayAccordingToAlignment:
                transformStudentsToDisplayAccordingToAlignment(
                  data.performanceInsights?.alignmentCategories
                ),
            },
          },
        }),
      },
    };
    return transformedData;
  };

  useEffect(() => {
    if (selectedCeeId) {
      getAllRoles();
      getAllRoleCount();
      getStudentList();
    }
  }, [selectedCeeId]);

  useEffect(() => {
    const fetchCeeIds = async () => {
      try {
        setLoading(true);
        const response = await services.get(
          `/collegeAdmin/cee?batch_id=${batchId}`
        );

        if (response && response.data.length > 0) {
          const ids = response.data.map((item) => item);
          setCEEOptions(ids);
          setDashboardData((prevData) => ({
            ...prevData,
            ceeOptions: ids,
          }));
          const lastCeeId = ids[ids.length - 1].id;
          setSelectedCeeId(lastCeeId);
          const dashboardResponse = await services.get(
            `/collegeAdmin/ceeAnalytics?cee_id=${lastCeeId}&batch_id=${batchId}`
          );
          if (Object.keys(dashboardResponse.data).length > 0) {
            const transformedData = transformBackendToDashboard(
              dashboardResponse,
              ids
            );
            setDashboardData(transformedData);
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCeeIds();
  }, [batchId]);
  console.log("roleCountList", roleCountList);
  const handleCeeIdChange = async (event) => {
    const newCeeId = event.target.value;
    const parseCeeId = parseInt(newCeeId);
    setSelectedCeeId(parseCeeId);

    try {
      setLoading(true);
      const dashboardResponse = await services.get(
        `/collegeAdmin/ceeAnalytics?cee_id=${parseCeeId}&batch_id=${batchId}`
      );
      if (Object.keys(dashboardResponse.data).length > 0) {
        const transformedData = transformBackendToDashboard(
          dashboardResponse,
          ceeOptions
        );
        setDashboardData(transformedData);
      } else {
        setDashboardData((prev) => {
          return { ceeOptions: prev.ceeOptions };
        });
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
      setDashboardData((prev) => {
        return { ceeOptions: prev.ceeOptions };
      });
    } finally {
      setLoading(false);
    }
  };
  const handleViewAllRoles = useCallback(() => {
    if (modalRoleList) {
      setIsRoleModalOpen(true);
    }
  }, [modalRoleList]);

  const handleRoleAnalysisModal = useCallback(() => {
    if (modalRoleList) {
      setRoleAnalysisModal(true);
    }
  }, [modalRoleList]);

  const handleViewStudents = useCallback(
    (studentsToDisplay = allModalStudents) => {
      let filteredStudents;
      if (Array.isArray(studentsToDisplay) && studentsToDisplay.length > 0) {
        if (typeof studentsToDisplay[0] === "number") {
          filteredStudents = allModalStudents.filter((student) =>
            studentsToDisplay.includes(student.user_id)
          );
        } else {
          filteredStudents = studentsToDisplay;
        }
      } else {
        filteredStudents = allModalStudents;
      }

      setModalStudentList(filteredStudents);
      setIsStudentModalOpen(true);
    },
    [allModalStudents]
  );

  useEffect(() => {
    const searchInput = document.getElementById("searchInput");
    const handleKeyPress = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        const searchValue = searchInput.value.toLowerCase();
        if (searchValue.trim() !== "" && modalStudentList) {
          const matchedStudents = allModalStudents.filter(
            (student) =>
              student.first_name?.toLowerCase()?.includes(searchValue) ||
              student.last_name?.toLowerCase()?.includes(searchValue)
          );
          handleViewStudents(matchedStudents);
        } else if (modalStudentList) {
          handleViewStudents(modalStudentList);
        }
      }
    };

    if (searchInput) {
      searchInput.addEventListener("keypress", handleKeyPress);
    }
    return () => {
      if (searchInput) {
        searchInput.removeEventListener("keypress", handleKeyPress);
      }
    };
  }, [dashboardData, handleViewStudents]);
  if (!dashboardData || loading) {
    return <CollegeDashboardSkeleton />;
  }

  console.log("dashboardData", dashboardData);
  const { sections, generalStats, ceeOptions } = dashboardData;
  const inCompletedStudents = generalStats.totalStudentsInBatch - generalStats.totalCEETakers;
  return (
    <div className="text-gray-800">
      <div className="max-width-7xl">
        <Header
          selectedCeeId={selectedCeeId}
          onCeeIdChange={handleCeeIdChange}
          ceeOptions={ceeOptions}
          quickStats={generalStats}
        />
        {generalStats && (
            <div style={{ display: "flex", flexDirection: "column", marginBottom: "5px",  gap: "5px" }}>
              {inCompletedStudents > 0 && (
                <div style={{ display: "flex", flexDirection: "row", gap: "5px", alignItems: "center",color: "red"}}>
                  <span >
                    {inCompletedStudents} student{inCompletedStudents > 1 ? "s" : ""} have not completed all required steps to generate their reports
                  </span>
                  <button onClick={() => setIsIncompleteStudentsModalOpen(true)} style={{ color: "red",border: "none",backgroundColor: "transparent" }} onMouseEnter={(e) => e.target.style.color = "blue"} onMouseLeave={(e) => e.target.style.color = "red"}>[View List]</button>
              </div>
              )}
              <span style={{ color: "red",fontSize: "13px" }}>
              The report shown below is available for {generalStats.totalCEETakers} student{generalStats.totalCEETakers > 1 ? "s" : ""} only
              </span>
              <IncompleteStudentsModal
                isOpen={isIncompleteStudentsModalOpen}
                onClose={() => setIsIncompleteStudentsModalOpen(false)}
                students={allModalStudents?.filter(student => student.exam_status !== "Report Declared")}
              />
            </div>
          )}
        {!sections ? (
          <div
            className="flex items-center justify-center text-xl"
            style={{ marginTop: "2rem" }}
          >
            {" "}
            No CEE Data Availiable
          </div>
        ) : (
          <>
            <BatchProfileSection
              data={sections.batchProfilePerformance}
              onViewAllRoles={handleViewAllRoles}
              onViewAllStudents={handleViewStudents}
              onSalaryAnalysis={handleRoleAnalysisModal}
            />

            <CEEPerformanceSection data={sections.ceePerformanceMetrics} />

            <CoreSkillsAssessmentSection
              data={sections.coreSkillsAssessment}
              onViewStudents={handleViewStudents}
            />
            <ThreePAnalysisCard
              data={sections.performanceInsights?.threePAnalysis}
              onViewStudents={handleViewStudents}
            />
            <div className="flex justify-center mb-8">
              <button
                onClick={() => {
                  const searchInput = document.getElementById("searchInput");
                  if (searchInput) {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    setTimeout(() => {
                      searchInput.focus();
                      searchInput.parentElement.classList.add(
                        "search-highlight"
                      );
                      setTimeout(() => {
                        searchInput.parentElement.classList.remove(
                          "search-highlight"
                        );
                      }, 3000);
                    }, 500);
                  }
                }}
                style={{ border: "none" }}
                className="px-6 py-3 bg-gradient-to-r from-primary-600 to-secondary-600 text-white rounded-lg shadow-md hover:shadow-lg transition-all duration-200 flex items-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 mr-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
                <span className="font-medium">Search Student Reports</span>
              </button>
            </div>
          </>
        )}
      </div>

      <RoleListModal
        isOpen={isRoleModalOpen}
        onClose={() => setIsRoleModalOpen(false)}
        roles={modalRoleList}
      />

      <RoleAnalysisModal
        isOpen={roleAnalysisModal}
        onClose={() => setRoleAnalysisModal(false)}
        roles={roleCountList}
      />

      <StudentListModal
        isOpen={isStudentModalOpen}
        onClose={() => setIsStudentModalOpen(false)}
        students={modalStudentList}
        selectedCeeId={selectedCeeId}
      />
    </div>
  );
};

export default CollegeDashboard;
